"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const windows_locales = require('windows-locale');
const iso639 = require("./iso-639");
const iso3166 = require("./iso-3166");
const iso15924 = require("./iso-15924");
const bcp47 = require("./bcp-47");
const lcid = require("./lcid");
const trace = false;
const all = [];
function getLocales() {
    if (all.length === 0) {
        trace && console.time('ISOLocale db');
        const windows_locale_keys = Object.keys(windows_locales);
        for (let i = 0, l = windows_locale_keys.length; i < l; ++i) {
            const windows_locale = windows_locales[windows_locale_keys[i]];
            const locale = {
                language: windows_locale.language,
                region: windows_locale.location,
                tag: windows_locale.tag,
                lcid: windows_locale.id,
                lcid_parts: lcid.parse(windows_locale.id)
            };
            const bcp47Data = bcp47.parse(locale.tag, { forgiving: true });
            locale.tag_bcp47 = bcp47Data;
            const iso639data = iso639.find(bcp47Data.language);
            if (iso639data) {
                locale.language_iso639 = iso639data;
                locale.language_local = iso639data.name_local;
            }
            else {
                trace && console.error(`${locale.tag} (${bcp47Data.language}) - no ISO639 entry !!`);
            }
            if (bcp47Data.script) {
                const iso15924data = iso15924.find(bcp47Data.script);
                if (iso15924data) {
                    locale.script_iso15924 = iso15924data;
                }
                else {
                    trace && console.error(`${locale.tag} (${bcp47Data.script}) - no ISO15924 entry !!`);
                }
            }
            if (bcp47Data.region) {
                const iso3166data = iso3166.find(bcp47Data.region);
                if (iso3166data) {
                    locale.region_iso3166 = iso3166data;
                }
                else {
                    trace && console.error(`${locale.tag} (${bcp47Data.region}) - no ISO3166 entry !!`);
                }
            }
            all.push(locale);
        }
        trace && console.timeEnd('ISOLocale db');
    }
    return all;
}
exports.getLocales = getLocales;
//# sourceMappingURL=iso-locales-db.js.map